export interface Tab {
  index: number;
  key: string;
  keyParams?: Record<string, string | number>;
  disabled?: boolean;
  unread?: boolean;
  preIcon?: string;
  postIcon?: string;
  iconSize?: number;
  tooltip?: string;
}

export interface TabLink {
  link: string;
  index: number;
  i18nKey: string;
}

export const getTabsByKeys = (keys: string[]): Tab[] => {
  return keys.map((key, index) => ({ index, key }));
};

export const disableTabsExceptCurrent = (tabs: Tab[], currentTabIndex: number): Tab[] => {
  return tabs.map(tab => (tab.index === currentTabIndex ? tab : { ...tab, disabled: true }));
};

export const enableTabs = (tabs: Tab[]): Tab[] => {
  return tabs.map(tab => ({ ...tab, disabled: false }));
};
